import { MutationTuple, useMutation } from '@apollo/client';
import { ClaimApproveWeldInput, ClaimApproveWeldPayload } from '@bechtel/types';
import { CLAIM_AND_APPROVE_WELD } from '@bechtel/client-gql';

export function useClaimAndApproveWeld(
  onActionCompleted?: () => void,
  refetchQueries?: string[]
): MutationTuple<{ claimApproveWeldPayload: ClaimApproveWeldPayload }, { input: ClaimApproveWeldInput }> {
  const response = useMutation<{ claimApproveWeldPayload: ClaimApproveWeldPayload }, { input: ClaimApproveWeldInput }>(
    CLAIM_AND_APPROVE_WELD,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: () => {
        if (onActionCompleted) onActionCompleted();
      },
      onError: () => {
        if (onActionCompleted) onActionCompleted();
      },
      refetchQueries,
    }
  );
  return response;
}
